export default {
  lang: 'pl',
  dir: 'ltr',
  common: {
    ok: 'OK',
    cancel: 'Anuluj',
    key_backspace: 'Backspace',
    key_del: 'Del',
    key_down: 'Dół',
    key_up: 'Góra',
    more_opts: 'Więcej opcji',
    url: 'URL',
    width: 'Szerokość',
    height: 'Wysokość'
  },
  misc: {
    powered_by: 'Zasilane przez'
  },
  ui: {
    toggle_stroke_tools: 'Pokaż/ukryj więcej narzędzi do obrysów',
    palette_info: 'Kliknij, aby zmienić kolor wypełnienia, shift-kliknij, aby zmienić kolor obrysu',
    zoom_level: 'Zmiana poziomu powiększenia',
    panel: 'Panel',
    panel_action: 'Kliknij, aby otworzyć panel boczny',
    quality: 'Jakość:',
    pathNodeTooltip: 'Przeciągnij węzeł, aby go przesunąć. Kliknij dwukrotnie węzeł, aby zmienić typ segmentu',
    pathCtrlPtTooltip: 'Przeciągnij punkt kontrolny, aby dostosować właściwości krzywej',
    pick_stroke_paint_opacity: 'Wybierz kolor i przezroczystość obrysu',
    pick_fill_paint_opacity: 'Wybierz kolor i przezroczystość wypełnienia',
    group_identify_label: 'Etykieta identyfikacji grupy',
    export_type_label: 'Wybierz typ obrazu do eksportu:'
  },
  properties: {
    id: 'Identyfikacja elementu',
    fill_color: 'Zmiana koloru wypełnienia',
    stroke_color: 'Zmiana koloru obrysu',
    stroke_style: 'Zmiana stylu kreskowanego obrysu',
    stroke_width: 'Zmiana szerokości obrysu o 1, shift-kliknij, aby zmienić o 0.1',
    pos_x: 'Zmiana współrzędnej X',
    pos_y: 'Zmiana współrzędnej Y',
    linecap_butt: 'Zakończenie linii: Proste',
    linecap_round: 'Zakończenie linii: Okrągłe',
    linecap_square: 'Zakończenie linii: Kwadratowe',
    linejoin_bevel: 'Łączenie linii: Skos',
    linejoin_miter: 'Łączenie linii: Kształt',
    linejoin_round: 'Łączenie linii: Okrągłe',
    angle: 'Zmiana kąta obrotu',
    blur: 'Zmiana wartości rozmycia Gaussa',
    opacity: 'Zmiana przezroczystości zaznaczonego elementu',
    circle_cx: "Zmiana współrzędnej cx koła",
    circle_cy: "Zmiana współrzędnej cy koła",
    circle_r: "Zmiana promienia koła",
    ellipse_cx: "Zmiana współrzędnej cx elipsy",
    ellipse_cy: "Zmiana współrzędnej cy elipsy",
    ellipse_rx: "Zmiana promienia x elipsy",
    ellipse_ry: "Zmiana promienia y elipsy",
    line_x1: "Zmiana początkowej współrzędnej x linii",
    line_x2: "Zmiana końcowej współrzędnej x linii",
    line_y1: "Zmiana początkowej współrzędnej y linii",
    line_y2: "Zmiana końcowej współrzędnej y linii",
    rect_height: 'Zmiana wysokości prostokąta',
    rect_width: 'Zmiana szerokości prostokąta',
    corner_radius: 'Zmiana promienia zaokrąglenia rogów prostokąta',
    image_width: 'Zmiana szerokości obrazu',
    image_height: 'Zmiana wysokości obrazu',
    image_url: 'Zmiana URL',
    node_x: "Zmiana współrzędnej x węzła",
    node_y: "Zmiana współrzędnej y węzła",
    seg_type: 'Zmiana typu segmentu',
    straight_segments: 'Proste',
    curve_segments: 'Krzywe',
    text_contents: 'Zmiana treści tekstu',
    font_family_label: 'Czcionka:',
    font_family: 'Zmiana rodziny czcionek',
    font_size: 'Zmiana rozmiaru czcionki',
    bold: 'Pogrubiony tekst',
    text_decoration_underline: 'Podkreślenie',
    text_decoration_linethrough: 'Przekreślenie',
    text_decoration_overline: 'Nadkreślenie',
    italic: 'Tekst pochylony',
    text_anchor_start: 'Wyrównaj tekst do początku',
    text_anchor_middle: 'Wyrównaj tekst do środka',
    text_anchor_end: 'Wyrównaj tekst do końca',
    text_letter_spacing: 'Zmiana odstępów między literami',
    text_word_spacing: 'Zmiana odstępów między słowami',
    text_length: 'Umożliwia określenie szerokości przestrzeni, w której będzie rysowany tekst',
    text_length_adjust: 'Dostosowanie długości',
    text_length_adjust_spacing: 'Odstępy',
    text_length_adjust_spacing_and_glyphs: 'Odstępy i glify',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'w',
    h_label: 'h',
    id_label: 'id',
    class_label: 'klasa',
    label: 'etykieta',
    class: 'Klasa elementu',
    serif: 'Szeryfowa',
    road_sign_normal: 'Znak drogowy',
    road_sign_condensed: 'Znak drogowy (zagęszczona)',
    sans_serif: 'Bezszeryfowa',
    cursive: 'Kursywa',
    fantasy: 'Fantazyjna',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'Times',
    prefs_and_content: 'Zapisz preferencje i zawartość SVG lokalnie',
    prefs_only: 'Zapisz tylko preferencje lokalnie',
    no_prefs_or_content: 'Nie zapisuj moich preferencji ani zawartości SVG lokalnie',
    jgraduate_pad: 'Wypełnienie',
    jgraduate_reflect: 'Odbicie',
    jgraduate_repeat: 'Powtórzenie'
  },
  tools: {
    main_menu: 'Menu główne',
    bkgnd_color_opac: 'Zmień kolor tła/przezroczystość',
    connector_no_arrow: 'Bez strzałki',
    fitToContent: 'Dopasuj do zawartości',
    fit_to_all: 'Dopasuj do całej zawartości',
    fit_to_canvas: 'Dopasuj do płótna',
    fit_to_layer_content: 'Dopasuj do zawartości warstwy',
    fit_to_sel: 'Dopasuj do zaznaczenia',
    align_relative_to: 'Wyrównaj względem ...',
    relativeTo: 'względem:',
    page: 'strona',
    largest_object: 'największy obiekt',
    selected_objects: 'wybrane obiekty',
    smallest_object: 'najmniejszy obiekt',
    export_img: 'Eksportuj',
    import_doc: 'Importuj SVG',
    align_to_page: 'Wyrównaj element do strony',
    align_bottom: 'Wyrównaj do dołu',
    align_center: 'Wyrównaj do środka',
    align_left: 'Wyrównaj do lewej',
    align_middle: 'Wyrównaj do środka',
    align_right: 'Wyrównaj do prawej',
    align_top: 'Wyrównaj do góry',
    mode_select: 'Narzędzie zaznaczania',
    mode_fhpath: 'Narzędzie ołówka',
    mode_line: 'Narzędzie linii',
    mode_rect: 'Narzędzie prostokąta',
    mode_square: 'Narzędzie kwadratu',
    mode_fhrect: 'Prostokąt ręczny',
    mode_ellipse: 'Elipsa',
    mode_circle: 'Koło',
    mode_fhellipse: 'Elipsa ręczna',
    mode_path: 'Narzędzie ścieżki',
    mode_text: 'Narzędzie tekstu',
    mode_image: 'Narzędzie obrazu',
    mode_zoom: 'Narzędzie powiększenia',
    no_embed: 'UWAGA: Tego obrazu nie można osadzić. Wyświetlanie będzie zależało od tego ścieżki.',
    undo: 'Cofnij',
    redo: 'Ponów',
    tool_source: 'Edytuj źródło',
    wireframe_mode: 'Tryb szkieletowy',
    clone: 'Duplikuj element(y)',
    del: 'Usuń element(y)',
    group_elements: 'Grupowanie elementów',
    make_link: 'Utwórz (hiper)łącze',
    set_link_url: 'Ustaw URL łącza (pozostaw puste, aby usunąć)',
    to_path: 'Konwertuj na ścieżkę',
    reorient_path: 'Przekieruj ścieżkę',
    ungroup: 'Rozgrupuj elementy',
    docprops: 'Właściwości dokumentu',
    editor_homepage: 'Strona główna SVG-Edit',
    move_bottom: 'Przesuń na tył',
    move_top: 'Przesuń na przód',
    node_clone: 'Klonuj węzeł',
    node_delete: 'Usuń węzeł',
    node_link: 'Połącz punkty kontrolne',
    add_subpath: 'Dodaj podścieżkę',
    openclose_path: 'Otwórz/zamknij podścieżkę',
    source_save: 'Zastosuj zmiany',
    cut: 'Wytnij',
    copy: 'Kopiuj',
    paste: 'Wklej',
    paste_in_place: 'Wklej na miejscu',
    delete: 'Usuń',
    group: 'Grupuj',
    move_front: 'Przesuń na przód',
    move_up: 'Przesuń do przodu',
    move_down: 'Przesuń do tyłu',
    move_back: 'Przesuń na tył',
    tool_unlink_use: 'Przerwij łącze do referencyjnego elementu (uczyń unikalnym)',
    ellipse_circle_tool: 'Narzędzie elipsa/koło',
    square_rect_tool: 'Narzędzie kwadrat/prostokąt',
    remember_this_choice: 'Zapamiętać ten wybór?',
    remember_this_choice_title: 'Jeśli wybierzesz brak przechowywania podczas zapamiętywania tego wyboru, URL zostanie zmieniony, aby uniknąć ponownego pytania.'
  },
  layers: {
    layer: 'Warstwa',
    layers: 'Warstwy',
    del: 'Usuń warstwę',
    move_down: 'Przesuń warstwę w dół',
    new: 'Nowa warstwa',
    rename: 'Zmień nazwę warstwy',
    move_up: 'Przesuń warstwę w górę',
    dupe: 'Duplikuj warstwę...',
    merge_down: 'Scal w dół',
    merge_all: 'Scal wszystko',
    move_elems_to: 'Przesuń elementy do:',
    move_selected: 'Przesuń wybrane elementy do innej warstwy'
  },
  config: {
    image_props: 'Właściwości obrazu',
    doc_title: 'Tytuł:',
    doc_dims: 'Wymiary płótna',
    included_images: 'Dołączone obrazy',
    image_opt_embed: 'Osadź dane (lokalne pliki)',
    image_opt_ref: 'Użyj referencji pliku',
    editor_prefs: 'Preferencje edytora',
    language: 'Język:',
    background: 'Tło edytora',
    editor_img_url: 'URL obrazu:',
    editor_bg_note: 'Uwaga: Tło nie zostanie zapisane z obrazem.',
    select_predefined: 'Wybierz predefiniowane:',
    units_and_rulers: 'Jednostki i linijki',
    show_rulers: 'Pokaż linijki',
    base_unit: 'Podstawowa jednostka:',
    grid: 'Siatka',
    snapping_onoff: 'Włączanie/wyłączanie przyciągania',
    snapping_stepsize: 'Krok przyciągania:',
    grid_color: 'Kolor siatki:',
    done: 'Zakończ',
    change_xxx_color: 'Zmień kolor xxx',
    pick_paint_opavity: 'Wybierz kolor i przezroczystość {{newValue}}',
    open_color_picker: 'Kliknij, aby otworzyć selektor kolorów',
    jpicker_title: 'Przeciągnij markery, aby wybrać kolor',
    jpicker_new_color: 'nowy',
    jpicker_current_color: 'aktualny',
    jpicker_tooltip_colors_new_color: 'Nowy kolor - Naciśnij „OK”, aby potwierdzić',
    jpicker_tooltip_colors_current_color: 'Kliknij, aby wrócić do oryginalnego koloru',
    jpicker_tooltip_buttons_ok: 'Zatwierdź wybór tego koloru',
    jpicker_tooltip_buttons_cancel: 'Anuluj i wróć do oryginalnego koloru',
    jpicker_tooltip_hue_radio: 'Ustaw na tryb koloru "Odcień"',
    jpicker_tooltip_hue_textbox: 'Wprowadź wartość "Odcień" (0-360°)',
    jpicker_tooltip_saturation_radio: 'Ustaw na tryb koloru "Nasycenie"',
    jpicker_tooltip_saturation_textbox: 'Wprowadź wartość "Nasycenie" (0-100%)',
    jpicker_tooltip_value_radio: 'Ustaw na tryb koloru "Wartość"',
    jpicker_tooltip_value_textbox: 'Wprowadź wartość "Wartość" (0-100%)',
    jpicker_tooltip_red_radio: 'Ustaw na tryb koloru "Czerwony"',
    jpicker_tooltip_red_textbox: 'Wprowadź wartość "Czerwony" (0-255)',
    jpicker_tooltip_green_radio: 'Ustaw na tryb koloru "Zielony"',
    jpicker_tooltip_green_textbox: 'Wprowadź wartość "Zielony" (0-255)',
    jpicker_tooltip_blue_radio: 'Ustaw na tryb koloru "Niebieski"',
    jpicker_tooltip_blue_textbox: 'Wprowadź wartość "Niebieski" (0-255)',
    jpicker_tooltip_alpha_radio: 'Ustaw na tryb koloru "Alfa"',
    jpicker_tooltip_alpha_textbox: 'Wprowadź wartość "Alfa" (0-100)',
    jpicker_tooltip_hex_textbox: 'Wprowadź wartość koloru "Hex" (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Wprowadź wartość "Alfa" (#00-#ff)',
    jgraduate_solid_color: 'Jednolity kolor',
    jgraduate_linear_gradient: 'Gradient liniowy',
    jgraduate_radial_gradient: 'Gradient promienisty',
    jgraduate_begin_point: 'Punkt początkowy',
    jgraduate_enter_starting_x: 'Wprowadź wartość x początkową od 0.0 do 1.0',
    jgraduate_enter_starting_y: 'Wprowadź wartość y początkową od 0.0 do 1.0',
    jgraduate_end_point: 'Punkt końcowy',
    jgraduate_enter_ending_x: 'Wprowadź wartość x końcową od 0.0 do 1.0',
    jgraduate_enter_ending_y: 'Wprowadź wartość y końcową od 0.0 do 1.0',
    jgraduate_center_point: 'Punkt centralny',
    jgraduate_enter_value_x: 'Wprowadź wartość x od 0.0 do 1.0',
    jgraduate_enter_value_y: 'Wprowadź wartość y od 0.0 do 1.0',
    jgraduate_focal_point: 'Punkt ogniskowy',
    jgraduate_match_center: 'Dopasuj środek:',
    jgraduate_enter_focal_x: 'Wprowadź wartość x od 0.0 do 1.0',
    jgraduate_enter_focal_y: 'Wprowadź wartość y od 0.0 do 1.0',
    jgraduate_spread_method: 'Metoda rozprzestrzeniania',
    jgraduate_radius: 'Promień:',
    jgraduate_set_radius: 'Kliknij, aby ustawić promień',
    jgraduate_ellip: 'Elipsa:',
    jgraduate_set_ellip: 'Kliknij, aby ustawić elipsę',
    jgraduate_angle: 'Kąt:',
    jgraduate_set_angle: 'Kliknij, aby ustawić kąt',
    jgraduate_deg: 'stopni:',
    jgraduate_opac: 'Przezroczystość:',
    jgraduate_set_opac: 'Kliknij, aby ustawić przezroczystość'
  },
  notification: {
    invalidAttrValGiven: 'Podano nieprawidłową wartość',
    noContentToFitTo: 'Brak zawartości do dopasowania',
    dupeLayerName: 'Warstwa o tej nazwie już istnieje!',
    enterUniqueLayerName: 'Wprowadź unikalną nazwę warstwy',
    enterNewLayerName: 'Wprowadź nową nazwę warstwy',
    layerHasThatName: 'Warstwa już ma taką nazwę',
    QmoveElemsToLayer: 'Przenieść wybrane elementy do warstwy \'%s\'?',
    QwantToClear: 'Czy chcesz wyczyścić rysunek?\nTo również usunie historię cofania!',
    QwantToOpen: 'Czy chcesz otworzyć nowy plik?\nTo również usunie historię cofania!',
    QerrorsRevertToSource: 'Wystąpiły błędy parsowania w źródle SVG.\nCzy wrócić do oryginalnego źródła SVG?',
    QignoreSourceChanges: 'Zignorować zmiany dokonane w źródle SVG?',
    featNotSupported: 'Funkcja nie jest obsługiwana',
    enterNewImgURL: 'Wprowadź nowy URL obrazu',
    defsFailOnSave: 'UWAGA: Z powodu błędu w przeglądarce, ten obraz może wyglądać nieprawidłowo (brak gradientów lub elementów). Po zapisaniu będzie jednak wyglądał poprawnie.',
    loadingImage: 'Ładowanie obrazu, proszę czekać...',
    saveFromBrowser: "Wybierz 'Zapisz jako...' w przeglądarce (możliwe przez menu plików lub menu kontekstowe po kliknięciu prawym przyciskiem myszy), aby zapisać ten obraz jako plik typu {{type}}.",
    noteTheseIssues: 'Zauważ również następujące problemy: ',
    unsavedChanges: 'Istnieją niezapisane zmiany.',
    enterNewLinkURL: 'Wprowadź nowy URL hiperłącza',
    errorLoadingSVG: 'Błąd: Nie udało się załadować danych SVG',
    URLLoadFail: 'Nie udało się załadować z URL',
    retrieving: "Pobieranie '%s' ...",
    popupWindowBlocked: 'Okno popup może być zablokowane przez przeglądarkę',
    exportNoBlur: 'Rozmyte elementy będą wyglądały jak nie rozmyte',
    exportNoforeignObject: 'Elementy foreignObject nie będą widoczne',
    exportNoDashArray: 'Linie będą wyglądały na wypełnione',
    exportNoText: 'Tekst może nie wyglądać zgodnie z oczekiwaniami',
    editorPreferencesMsg: 'Domyślnie i tam, gdzie jest to wspierane, SVG-Edit może przechowywać preferencje edytora oraz zawartość SVG lokalnie na twoim komputerze, aby nie trzeba było ich ponownie dodawać za każdym razem, gdy ładujesz SVG-Edit. Jeśli z powodów prywatności nie chcesz przechowywać tych informacji na swoim komputerze, możesz zmienić domyślne ustawienie poniżej.',
    source_dialog_note: 'Skopiuj zawartość tego pola do edytora tekstu, a następnie zapisz plik z rozszerzeniem .svg.'
  }
}
